import i18next from 'i18next';
import OrdersLogo from '../../../../../components/Shared/Icons/OrdersLogo';
import permissions from '../../../../permissions';
import ClaimReports from '../../../../../components/ClaimReport/List';

// const CLAIM_REPORT_ROUTE_LIST_DS = {
//   path: '/:currentAccountUuid/accounts/:accountUuid/claimReport',
//   exact: true,
//   additional: {
//     component: ClaimReports,
//     protected: true,
//     title: i18next.t('titles:claimReports'),
//     icon: OrdersLogo,
//     permission: permissions.CLAIM_REPORTS_GET,
//   },
// };

const CLAIM_REPORT_ROUTE_LIST = {
  path: '/:currentAccountUuid/claimReport',
  exact: true,
  additional: {
    component: ClaimReports,
    protected: true,
    title: i18next.t('titles:claimReports'),
    icon: OrdersLogo,
    permission: permissions.CLAIM_REPORTS_GET,
  },
};

export const CLAIM_REPORT_ROUTES = {
  // ------- For child accounts ------
  // listDS: CLAIM_REPORT_ROUTE_LIST_DS,

  // ------- For current accounts ------
  list: CLAIM_REPORT_ROUTE_LIST,
};

